import React, { useEffect, useRef, useState } from 'react';
import Switch from "react-bootstrap-switch";

import { Spinner } from "reactstrap";

const GenericSwitch = function({
                                   id = null,
                                   initialState = false,
                                   requestData = {},
                                   onChange = null,
                                   labelText = '',
}) {
    const [saving, setSaving] = useState(false)
    const [value, setValue] = useState( initialState )

    const isMounted = useRef( true)

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const handleChange = async (element, state) => {
        if(!onChange)
            return

        if(!isMounted)
            return

        setValue(state)
        setSaving(true)

        const data = await onChange(id, requestData, state)

        //ejecutar solo si el componente esta montado
        if(isMounted) {
            if(!data?.id)
                setValue(!state)

            setSaving(false)
        }
    }

    return(<>
        {
            saving ? <Spinner animation="border" />
            : <Switch
                animate={ true }
                labelText={ labelText }
                offText={ "No" }
                onText={ "Si" }
                value={ value }
                disabled={ saving }
                bsSize='mini'
                onChange={ handleChange }
            />
        }
    </>);
}

export default GenericSwitch